import { Group, MantineSize, Stack, Text, createStyles } from '@mantine/core';

interface SafeTextProps {
  data?: JSX.Element | string | number | null | undefined;
  size?: MantineSize;
  weight?: number;
  dataCy?: string;
  breakWord?: boolean;
}

export const SafeText: React.FC<SafeTextProps> = ({
  data,
  size,
  weight,
  dataCy,
  breakWord,
}) => {
  return data && data !== 'N/A' && data !== '.' ? (
    <Text
      size={size}
      weight={weight}
      data-cy={dataCy}
      style={{
        whiteSpace: breakWord ? 'normal' : 'nowrap',
        wordBreak: breakWord ? 'break-word' : 'normal',
      }}
    >
      {data}
    </Text>
  ) : (
    <Text size='sm' color='dimmed'>
      N/A
    </Text>
  );
};

export const TextInfo = (props: {
  label: JSX.Element | string | number | null | undefined;
  value?: JSX.Element | string | number | null | undefined;
  dataCy?: string;
  orientation?: 'vertical' | 'horizontal';
  breakWord?: boolean;
}) => {
  const { label, value, dataCy, orientation, breakWord } = props;

  return orientation === 'horizontal' ? (
    <Group spacing='xs'>
      <SafeText data={label} size='sm' weight={600} />
      <SafeText data={value} size='sm' dataCy={dataCy} breakWord={breakWord} />
    </Group>
  ) : (
    <Stack spacing='xs'>
      <SafeText data={label} size='sm' weight={600} />
      <SafeText data={value} size='sm' dataCy={dataCy} breakWord={breakWord} />
    </Stack>
  );
};

const useStyles = createStyles(() => {
  return {
    convenienceFee: {
      whiteSpace: 'nowrap',
    },
    tableContainer: {
      whiteSpace: 'nowrap',
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  };
});
